<template>
    <div class="flex flex-col w-full">
        <label v-if="label" class="font-bold mb-1">{{ label }}</label>

        <my-select v-model="selectedYear" :name="name" :error="error" :placeholder="placeholder" :options="years" />
    </div>
</template>

<script>
import FormInputMixin from './form_inputs_mixin';

export default {
    mixins: [FormInputMixin],

    props: {
        afterYear: {
            type: String,
            default: null
        },
        maxYear: {
            type: String,
            default: '2030'
        }
    },

    data() {
        return {
            years: {},
            selectedYear: null
        };
    },

    watch: {
        selectedYear: function() {
            this.onDateChanged();
        },

        value: function(newVal) {
            this.parseAndSetDatesFromValue(newVal);
        },

        afterYear: function() {
            this.selectedYear = null;
            this.setYears();
        }
    },

    created() {
        this.setYears();
        this.parseAndSetDatesFromValue(this.value);
    },

    methods: {
        onDateChanged() {
            if (!this.selectedYear) {
                this.$emit('input', null);
                return;
            }

            this.$emit('input', this.selectedYear);
        },

        setYears() {
            let currentYear = new Date().getFullYear();

            if (this.maxYear) {
                currentYear = this.maxYear;
            }

            let yearsObj = {};

            let startingYear = 1950;

            if (this.afterYear) {
                startingYear = this.afterYear;
            }

            for (let year = startingYear; year <= currentYear; year++) {
                yearsObj[year.toString()] = year.toString();
            }

            this.years = yearsObj;
        },

        parseAndSetDatesFromValue(date) {
            if (date === null) {
                this.selectedYear = null;
                return;
            }

            let dateObj = new Date(date);

            this.selectedYear = dateObj.getFullYear().toString();
        }
    }
};
</script>
